import { SvgIcon } from '@cinch-labs/design-system'
import styles from './location-title.module.css'

type LocationTitleProps = {
  location: string
}

export const LocationTitle = ({ location }: LocationTitleProps) => (
  <div className={styles.locationTitleContainer}>
    <SvgIcon name="location" size={20} />
    <span>{location}</span>
  </div>
)
